/**
 * File primary-navigation.js.
 *
 * Required to open and close the mobile navigation.
 */

/**
 * Toggle an attribute's value
 *
 * @param {Element} el - The element.
 * @param {boolean} withListeners - Whether we want to add/remove listeners or not.
 */
function toggleAriaExpanded(el, withListeners) {
    if ('true' !== el.getAttribute('aria-expanded')) {
        el.setAttribute('aria-expanded', 'true');
        submenuPosition(el.parentElement);
        if (withListeners) {
            document.addEventListener('click', collapseMenuOnClickOutside);
        }
    } else {
        el.setAttribute('aria-expanded', 'false');
        if (withListeners) {
            document.removeEventListener('click', collapseMenuOnClickOutside);
        }
    }
}

function collapseMenuOnClickOutside(event) {
    if (!document.getElementById('site-navigation').contains(event.target)) {
        document.getElementById('site-navigation').querySelectorAll('.sub-menu-toggle').forEach(function (button) {
            button.setAttribute('aria-expanded', 'false');
        });
    }
}

/**
 * Changes the position of submenus so they always fit the screen horizontally.
 *
 * @param {Element} li - The li element.
 */
function submenuPosition(li) {
    var subMenu = li.querySelector('ul.sub-menu'),
        rect,
        right,
        windowWidth;

    if (!subMenu) {
        return;
    }

    rect = subMenu.getBoundingClientRect();
    right = Math.round(rect.right);
    windowWidth = Math.round(window.innerWidth);

    if (right > windowWidth) {
        subMenu.classList.add('submenu-reposition-right');
    }
}

/**
 * Handle clicks on submenu toggles.
 *
 * @param {Element} el - The element.
 */
function expandSubMenu(el) { // jshint ignore:line
    // Close other expanded items.
    el.closest('nav').querySelectorAll('.sub-menu-toggle').forEach(function (button) {
        if (button !== el) {
            button.setAttribute('aria-expanded', 'false');
        }
    });

    // Toggle aria-expanded on the button.
    toggleAriaExpanded(el, true);

    // On tab-away collapse the menu.
    el.parentNode.querySelectorAll('ul > li:last-child > a').forEach(function (linkEl) {
        linkEl.addEventListener('blur', function (event) {
            if (!el.parentNode.contains(event.relatedTarget)) {
                el.setAttribute('aria-expanded', 'false');
            }
        });
    });
}

(function () {
    /**
     * Menu Toggle Behaviors
     *
     * @param {string} id - The ID.
     */
    var navMenu = function (id) {
        var wrapper = document.body, // this is the element to which a CSS class is added when a mobile nav menu is open
            mobileButton = document.getElementById(id + '-mobile-menu'),
            navMenuEl = document.getElementById('site-navigation');

        // If there's no nav menu, none of this is necessary.
        if (!navMenuEl) {
            return;
        }

        if (mobileButton) {
            mobileButton.onclick = function () {
                wrapper.classList.toggle(id + '-navigation-open');
                wrapper.classList.toggle('lock-scrolling');
                toggleAriaExpanded(mobileButton);
                mobileButton.focus();
            };
        }

        /**
         * Trap keyboard navigation in the menu modal.
         */
        document.addEventListener('keydown', function (event) {
            var modal, elements, selectors, lastEl, firstEl, activeEl, tabKey, shiftKey, escKey;
            if (!wrapper.classList.contains(id + '-navigation-open')) {
                return;
            }

            modal = document.querySelector('.' + id + '-navigation');
            selectors = 'input, a, button';
            elements = modal.querySelectorAll(selectors);
            elements = Array.prototype.slice.call(elements);
            tabKey = event.keyCode === 9;
            shiftKey = event.shiftKey;
            escKey = event.keyCode === 27;
            activeEl = document.activeElement; // eslint-disable-line @wordpress/no-global-active-element
            lastEl = elements[elements.length - 1];
            firstEl = elements[0];

            if (escKey) {
                event.preventDefault();
                wrapper.classList.remove(id + '-navigation-open', 'lock-scrolling');
                toggleAriaExpanded(mobileButton);
                mobileButton.focus();
            }

            if (!shiftKey && tabKey && lastEl === activeEl) {
                event.preventDefault();
                firstEl.focus();
            }

            if (shiftKey && tabKey && firstEl === activeEl) {
                event.preventDefault();
                lastEl.focus();
            }

            // If there are no elements in the menu, don't move the focus
            if (tabKey && firstEl === lastEl) {
                event.preventDefault();
            }
        });

        navMenuEl.querySelectorAll('.menu-wrapper > .menu-item-has-children').forEach(function (li) {
            li.addEventListener('mouseenter', function () {
                this.querySelector('.sub-menu-toggle').setAttribute('aria-expanded', 'true');
                this.querySelector('.sub-menu').classList.add('open');
                this.querySelector('.sub-menu').classList.remove('close');
                submenuPosition(li);
            });
            li.addEventListener('mouseleave', function () {
                this.querySelector('.sub-menu').classList.remove('open');
                this.querySelector('.sub-menu').classList.add('close');
                this.querySelector('.sub-menu-toggle').setAttribute('aria-expanded', 'false');
            });
            var button = li.querySelector('.sub-menu-toggle');
            button.addEventListener('click', function () {
                expandSubMenu(this);
            })
        });
    };

    window.addEventListener('load', function () {
        new navMenu('primary');
    });
}());

/**
 * Set mobile menu and filters position when promo box is active
 */
export function setMobileMenuPosition() {

    const topBox = document.querySelector( '.header .top-box' );

    if ( ! topBox || ( screen.width > 767 && window.innerWidth > 767 ) ) {
        return;
    }

    const boxHeight = topBox.offsetHeight;
    const menu = document.querySelector( '.primary-menu-container' );
    const closeButton = document.querySelector( '.menu-button-container .close' );
    const filters = document.querySelector( '#left-column' );

    menu.style.top = `${ boxHeight + 81 }px`;
    closeButton.style.marginTop = `${ boxHeight }px`;

    if ( filters ) {
        filters.style.top = `${ boxHeight + 80 }px`;
        filters.style.height = `calc(100% - ${boxHeight + 80}px)`;
    }

}

window.addEventListener( 'DOMContentLoaded', () => {
    setMobileMenuPosition();
})
